import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IOmniSetup,
  IOmniSetupItem,
  OMNI_SETUP_STEPS_KEYS,
} from '../../models/omni-setup.model';
import { SLICE_NAMES } from '../constants';

const storageIsPostInstall = localStorage.getItem('omniSetupIsPostInstall');
const storageSnoozeTS = localStorage.getItem('omniSetupSnoozeTs');
const storageIsFinished = localStorage.getItem('omniSetupIsFinished');
const storageIsMinimized = localStorage.getItem('omniSetupIsMinimized');
const itemsKeysToDisplay = [
  OMNI_SETUP_STEPS_KEYS.INSTALL_BLOCKSITE,
  // OMNI_SETUP_STEPS_KEYS.ENABLE_BLOCKING_BY_CATEGORY,
  OMNI_SETUP_STEPS_KEYS.ADD_ITEM_TO_BLOCKSITE,
  // OMNI_SETUP_STEPS_KEYS.GET_PERSONALIZED_SUGGESTIONS,
  OMNI_SETUP_STEPS_KEYS.PIN_EXTENSION,
  OMNI_SETUP_STEPS_KEYS.SEE_INSIGHTS,
  OMNI_SETUP_STEPS_KEYS.TRY_VISIT_BLOCKED_SITE,
  OMNI_SETUP_STEPS_KEYS.GET_MOBILE_LINK,
];
const storageItems = localStorage.getItem('omniSetupItems');
const defaultItems: IOmniSetupItem[] = [
  {
    key: OMNI_SETUP_STEPS_KEYS.INSTALL_BLOCKSITE,
    isChecked: true,
    label: 'omniSetup.itemInstallBlocksite',
    weight: 15,
  },
  {
    key: OMNI_SETUP_STEPS_KEYS.ENABLE_BLOCKING_BY_CATEGORY,
    isChecked: false,
    label: 'omniSetup.itemBlockingByCategory',
    weight: 20,
  },
  {
    key: OMNI_SETUP_STEPS_KEYS.ADD_ITEM_TO_BLOCKSITE,
    isChecked: false,
    label: 'omniSetup.itemAddBlockItem',
    weight: 15,
  },
  {
    key: OMNI_SETUP_STEPS_KEYS.GET_PERSONALIZED_SUGGESTIONS,
    isChecked: false,
    label: 'omniSetup.itemSuggestions',
    weight: 15,
  },
  {
    key: OMNI_SETUP_STEPS_KEYS.PIN_EXTENSION,
    isChecked: false,
    label: 'omniSetup.itemPinExtension',
    weight: 15,
  },
  {
    key: OMNI_SETUP_STEPS_KEYS.SEE_INSIGHTS,
    isChecked: false,
    label: 'omniSetup.itemSeeInsights',
    weight: 15,
  },
  {
    key: OMNI_SETUP_STEPS_KEYS.TRY_VISIT_BLOCKED_SITE,
    isChecked: false,
    label: 'omniSetup.itemTryBlockSite',
    weight: 10,
  },
  {
    key: OMNI_SETUP_STEPS_KEYS.GET_MOBILE_LINK,
    isChecked: false,
    label: 'omniSetup.itemMobileLink',
    weight: 10,
  },
];
const items = (
  storageItems ? (JSON.parse(storageItems) as IOmniSetupItem[]) : defaultItems
).filter(tmpItem => itemsKeysToDisplay.includes(tmpItem.key));
// Initial state
const initialState: IOmniSetup = {
  snoozeTS: storageSnoozeTS ? parseInt(storageSnoozeTS) : 0,
  isFinished: storageIsFinished === 'true',
  isMinimized: storageIsMinimized === 'true',
  isPostInstall: storageIsPostInstall === 'true',
  items: items,
};

const omniSetupSlice = createSlice({
  name: SLICE_NAMES.OMNI_SETUP,
  initialState,
  reducers: {
    omniSetupSetIsFinished: state => {
      localStorage.setItem('omniSetupIsFinished', 'true');
      return { ...state, isFinished: true };
    },
    omniSetupSetSnooze: state => {
      localStorage.setItem('omniSetupSnoozeTs', Date.now().toString());
      return { ...state, snoozeTS: Date.now() };
    },
    omniSetupToggleMinimize: state => {
      localStorage.setItem(
        'omniSetupIsMinimized',
        !state.isMinimized ? 'true' : 'false'
      );
      return { ...state, isMinimized: !state.isMinimized };
    },
    omniSetupSetIsPostInstall: state => {
      localStorage.setItem('omniSetupIsPostInstall', 'true');
      return { ...state, isPostInstall: true };
    },
    omniSetupCheckStep: (state, action: PayloadAction<string>) => {
      const step = state.items.find(tmpItem => tmpItem.key === action.payload);
      if (step) {
        step.isChecked = true;
      }
      localStorage.setItem('omniSetupItems', JSON.stringify(state.items));
      return state;
    },
  },
});

export const {
  omniSetupSetIsFinished,
  omniSetupSetSnooze,
  omniSetupToggleMinimize,
  omniSetupSetIsPostInstall,
  omniSetupCheckStep,
} = omniSetupSlice.actions;

export const omniSetupReducer = omniSetupSlice.reducer;
